export const SELECT = `Select`;
export const RECORD_OPTIONS = 'RecordOptions';
